<template>
  <div class="vipcenter">
    <div class="mtop">
      <img src="../assets/gzmalogo.png" alt="" />
      <h1>个人中心</h1>
    </div>
    <div class="centerhead">
      <div class="minfo">
        <img :src="HeadImg != '' ? HeadImg : '../assets/gzmalogo.png'" alt="" />
        <div class="mtext">
          <p>{{ NickName }}</p>
          <p>{{ Mobile }}</p>
        </div>
      </div>
      <img src="../assets/centertopbg.png" />
    </div>
    <div class="examnav">
      <div class="examicon">
        <van-grid :column-num="4">
          <van-grid-item
            v-for="(item, index) in navimg"
            :key="index"
            :icon="item.imgurl"
            :text="item.name"
            @click="PopupDev(item)"
          />
        </van-grid>
      </div>
      <div class="exambottom"></div>
    </div>
    <div class="navlist">
      <ul>
        <li v-if="UserType == 3">
          <router-link to="/ExamTimeList?IsOnline=1">
            <img src="../assets/kgps.png" alt="" />
            <span>考官评审</span>
            <van-icon name="arrow" />
          </router-link>
        </li>
        <li v-if="UserType == 3">
          <router-link to="/ExamTimeList?IsOnline=0">
            <img src="../assets/wdyk.png" alt="" />
            <span>现场评审</span>
            <van-icon name="arrow" />
          </router-link>
        </li>
        <li>
          <router-link to="/MyEnroll">
            <img src="../assets/wdbm.png" alt="" />
            <span>我的报名</span>
            <van-icon name="arrow" />
          </router-link>
        </li>

        <!-- 
                <li>
                    <router-link to="">
                        <img src="../assets/yhq.png" alt="">
                        <span>优惠券</span>
                        <van-icon name="arrow" />
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <img src="../assets/sqrh.png" alt="">
                        <span>申请入会</span>
                        <van-icon name="arrow" />
                    </router-link>
                </li> -->
        <li>
          <router-link to="" @click.native="ShowChangePwdDig">
            <img src="../assets/xgmm.png" alt="" />
            <span>密码修改</span>
            <van-icon name="arrow" />
          </router-link>
        </li>
        <li>
          <router-link to="" @click.native="ShowChangeUserInfoDig">
            <img src="../assets/zlxg.png" alt="" />
            <span>资料修改</span>
            <van-icon name="arrow" />
          </router-link>
        </li>
      </ul>
    </div>
    <van-button
      class="exitbtn"
      type="primary"
      color="linear-gradient(to right, #ff6034, #ee0a24)"
      round
      block
      @click="Out"
      >退出登录</van-button
    >
    <footerTabber />
    <van-dialog
      v-model="ShowChangePwd"
      title="修改密码"
      show-cancel-button
      confirm-button-text="确认修改"
      :before-close="beforeClose"
    >
      <van-form ref="changepwd">
        <van-field
          v-model="ChangePWDInfo.OPWD"
          type="password"
          label="旧密码"
          placeholder="请输入旧密码"
          :rules="[{ required: true, message: '请输入旧密码' }]"
        />
        <van-field
          v-model="ChangePWDInfo.NPWD"
          type="password"
          label="新密码"
          placeholder="请输入新密码"
          :rules="[{ required: true, message: '请输入新密码' }]"
        />
        <van-field
          v-model="ChangePWDInfo.RPWD"
          type="password"
          label="重复密码"
          placeholder="请重复输入新密码"
          :rules="[{ required: true, message: '请重复输入新密码' }]"
        />
      </van-form>
    </van-dialog>

    <van-dialog
      v-model="ShowUserInfo"
      title="修改用户信息"
      show-cancel-button
      confirm-button-text="确认修改"
      :before-close="beforeUserClose"
    >
      <van-form ref="changepwd">
        <van-field
          v-model="UserInfo.NickName"
          label="昵称"
          placeholder="请输入您的昵称"
          :rules="[{ required: true, message: '请输入您的昵称' }]"
        />
        <van-field
          v-model="UserInfo.Name"
          label="姓名"
          placeholder="请输入您的姓名"
          :rules="[{ required: true, message: '请输入您的姓名' }]"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script scoped>
import footerTabber from "@/components/footerTabber.vue";
import { Toast } from "vant";
import { ChangePWD, GetUserInfo, UpdateUserInfo } from "@/api/login";
import { setNickName, setHeadImg } from "@/Utils/auth";
import store from "../store";

const defaultChangePWDInfo = {
  OPWD: null,
  NPWD: null,
  RPWD: null
};
export default {
  components: {
    footerTabber
  },
  data() {
    return {
      navimg: [
        {
          name: "在线报名",
          imgurl: require("../assets/sy-10.png"),
          navurl: "/ExamApply",
          isshow: 1
        },
        {
          name: "上传视频",
          imgurl: require("../assets/sy-11.png"),
          navurl: "/ExamList",
          isshow: 1
        },
        {
          name: "查询考场",
          imgurl: require("../assets/sy-12.png"),
          navurl: "/ExamTimeInfo",
          isshow: 1
        },
        {
          name: "成绩查询",
          imgurl: require("../assets/sy-13.png"),
          navurl: "/ExamResultInfo",
          isshow: 1
        }
      ],
      NickName: "",
      HeadImg: "",
      Mobile: "",
      UserInfo: {},
      UserType: this.$store.getters.usertype,
      ShowChangePwd: false,
      ShowUserInfo: false,
      ChangePWDInfo: Object.assign({}, defaultChangePWDInfo)
    };
  },
  methods: {
    PopupDev(item) {
      if (item.isshow == 0) {
        this.$toast.fail("敬请期待！");
        return;
      } else {
        this.$router.push(item.navurl);
      }
    },
    Out() {
      store.dispatch("FedLogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    ShowChangePwdDig() {
      this.ShowChangePwd = true;
      this.ChangePWDInfo = Object.assign({}, defaultChangePWDInfo);
    },
    ShowChangeUserInfoDig() {
      GetUserInfo().then(res => {
        this.ShowUserInfo = true;
        this.UserInfo = res.item;
      });
    },
    beforeUserClose(action, done) {
      if (action == "confirm") {
        UpdateUserInfo(this.UserInfo)
          .then(res => {
            Toast.success("用户基本信息修改成功");
            this.NickName = this.UserInfo.NickName;
            setNickName(this.NickName);
            done();
          })
          .catch(() => {
            done(false);
          });
      } else {
        done();
      }
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        if (!this.ChangePWDInfo.OPWD || this.ChangePWDInfo.OPWD === "") {
          Toast.fail("请输入旧密码");
          done(false);
          return;
        }
        if (!this.ChangePWDInfo.NPWD || this.ChangePWDInfo.NPWD === "") {
          Toast.fail("请输入新密码");
          done(false);
          return;
        }
        if (!this.ChangePWDInfo.RPWD || this.ChangePWDInfo.RPWD === "") {
          Toast.fail("请重复输入新密码");
          done(false);
          return;
        }
        if (this.ChangePWDInfo.NPWD != this.ChangePWDInfo.RPWD) {
          Toast.fail("两次输入的密码不一致");
          done(false);
          return;
        }
        ChangePWD({
          OPWD: this.ChangePWDInfo.OPWD,
          PWD: this.ChangePWDInfo.NPWD
        })
          .then(res => {
            Toast.success("密码修改成功,三秒后请重新登录");
            setTimeout(function() {
              store.dispatch("FedLogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
            }, 3000);
          })
          .catch(() => {
            done(false);
          });
      } else {
        done();
      }
    }
  },
  created() {
    this.NickName = this.$store.getters.nickname;
    this.HeadImg = this.$store.getters.headimg;
    this.Mobile = this.$store.getters.mobile;
    this.UserType = this.$store.getters.usertype;
  },
  mounted() {
    this.UserType = this.$store.getters.usertype;
  }
};
</script>

<style>
.vipcenter {
  background: url(../assets/loginbg.jpg) #100f5d no-repeat top;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 60px;
}
.mtop {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  padding: 10px 0;
}
.mtop img {
  width: 8vw;
  margin: 0 5px;
}
.mtop h1 {
  color: #fff;
  flex: 1;
  display: flex;
  justify-content: center;
  font-size: 4.267vw;
}
.centerhead {
  width: 94.667vw;
  margin: 5px auto;
  position: relative;
}
.centerhead img {
  width: 100%;
}
.centerhead .minfo {
  position: absolute;
  left: 10%;
  top: 20%;
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}
.centerhead .minfo img {
  width: 60px;
  height: 70px;
  border-radius: 5%;
  margin-right: 10px;
}
.centerhead .minfo .mtext {
  color: #fff;
  text-align: left;
  line-height: 1.5;
}

.examicon .van-grid .van-grid-item .van-grid-item__content {
  padding: 16px 1px;
  background: transparent;
}
.examicon .van-grid .van-grid-item .van-grid-item__content::after,
.quick-nav .van-hairline--top::after {
  border: 0;
}
.examicon .van-grid .van-grid-item .van-grid-item__content::after,
.examicon.van-hairline--top::after,
.hot-news .van-hairline--top::after {
  border: 0;
}
.examicon .van-grid .van-grid-item .van-grid-item__content::after,
.examicon .van-hairline--top::after {
  border: 0;
}
.examicon
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-icon
  .van-icon__image {
  width: 2em;
  height: 2em;
}
.examicon
  .van-grid
  .van-grid-item
  .van-grid-item__content
  .van-grid-item__text {
  font-size: 3.8vw;
  color: #333;
}
.examnav {
  width: 94.667vw;
  margin: 6vh auto 1vh;
  position: relative;
  height: 12vh;
}
.examnav .examicon {
  position: absolute;
  bottom: 2vh;
  width: 90%;
  left: 5%;
}
.examnav .examicon .van-grid {
  background: transparent;
}
.examnav .exambottom {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  height: 12vh;
}

.navlist {
  width: 94.667vw;
  margin: 15px auto;
  background: #fff;
  border-radius: 8px;
}
.navlist ul {
  padding: 10px;
}
.navlist ul li a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px #f2f2f2;
  padding: 15px 5px;
  color: #888;
}
.navlist ul li a img {
  flex: 1;
  width: 4.267vw;
}
.navlist ul li a span {
  flex: 6;
  text-align: left;
  padding-left: 15px;
}
.navlist ul li a .van-icon {
  color: #e6e6e6;
  font-size: 4.267vw;
  flex: 1;
}
.vipcenter .exitbtn {
  width: 94.667vw;
  margin: 0 auto;
}
</style>
